import React, { memo, useCallback, useMemo } from 'react'
import { TimeLineContentHeaderWrapper, TimeLineContentWrapper } from '../../../styles/styles'
import { ActivityAvito } from '../../../types/types'
import TimelineItemHeaderText from '../activity-timeline-item-header-text/activity-timeline-item-header-text'
import TimelineItemHeader from '../activity-timeline-item-header/activity-timeline-item-header'
import { formatDate } from '../../../hooks/useFormatDate'
import { TimelineItemProps } from '../activity-timeline-Item'

type ActivityTimelineAvitoType = Omit<TimelineItemProps, 'data'>

interface ActivityTimelineAvitoProps extends ActivityTimelineAvitoType {
  className?: string
  data?: ActivityAvito
}

const ActivityTimelineAvitoComponent: React.FC<ActivityTimelineAvitoProps> = (
  props: ActivityTimelineAvitoProps,
) => {
  const { date, user, data } = props

  const getBgColor = useCallback(() => {
    if (data?.avitoType === 'avito-note') {
      if (data?.direction === 'Менеджер') return '#cfffcc'
      return '#ccd7ff'
    }
    return ''
  }, [data])

  const bgColor = getBgColor()

  const formattedDate = useMemo<string>(() => formatDate(date), [date])

  return (
    <TimeLineContentWrapper color={bgColor}>
      <TimeLineContentHeaderWrapper>
        {data?.avitoType !== 'avito-top' ? (
          <TimelineItemHeader title={data?.title} date={date} />
        ) : (
          <TimelineItemHeaderText title={data?.title} />
        )}
      </TimeLineContentHeaderWrapper>
      <>
        {data?.avitoType === 'avito-top' ? (
          <>
            <div>
              <p>
                <b> {formattedDate}</b>
              </p>
            </div>
            <div>
              {data?.content?.split('\n')?.map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
          </>
        ) : (
          <div>
            {user?.name}: {data?.content}
          </div>
        )}
      </>
    </TimeLineContentWrapper>
  )
}

const ActivityTimelineAvito: React.FC<ActivityTimelineAvitoProps> = memo(ActivityTimelineAvitoComponent)

ActivityTimelineAvito.displayName = 'ActivityTimelineAvito'
export default ActivityTimelineAvito
